
/**
 * This is for encoding a bibleVerse data sent through the url
 * @param {*} podcastId
 * @param {*} extra
 * @returns
 */
export function encodeUrlData( podcastId = null, ...extra) {
    return btoa(JSON.stringify({ podcastId, ...extra }));
}

/**
 * Decode the Data
 * @param {String} encodedData
 * @returns {Object}
 * ```json
 * {
 *    "type":"string",
 *    "date":"string",
 *  }
 * ```
 */
export const decodeUrlData = (encodedData) => {
    try {
        const data = JSON.parse(atob(encodedData));
        return {
            // type: data.type,
            // date: data.date,
            ...data,
        };
    } catch (error) {
        log("Error decoding data:", error);
        return null; // or handle the error in an appropriate way
    }
};


